// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/carousel-fullwidth/carousel-fullwidth.component.scss
// module id = 192
// module chunks = 0